module.exports = __webpack_public_path__ + "static/media/empty-locations.3d819329.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/empty-locations.svg
// module id = 1196
// module chunks = 0